import type { PlatformInfo } from '@discovr/types';

interface RowWithPlatformIdentity {
  creator?: { name?: string | null } | null;
  /** platform is guaranteed non-null on all V2 roster entry types. */
  platform: PlatformInfo;
}

/**
 * Returns the best display name for a roster row.
 *
 * Preference: platform channel name → platform username → "Creator".
 * creator.name is intentionally skipped — users set their name on onboarding,
 * and social handle / channel name is the correct display identity on the roster.
 */
export function rowDisplayName(row: RowWithPlatformIdentity): string {
  return row.platform.name || row.platform.username || 'Creator';
}
